// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"795":"1eb8d830","900":"b49f6ca5"}[chunkId] + ".chunk.js";
};